import React from 'react';
import { MaintenanceEntitySection } from './MaintenanceEntitySection';

const PlantMaintenance = () => (
  <div className="space-y-6 min-w-0">
    <div>
      <h2 className="text-xl font-semibold text-gray-900">Plant maintenance</h2>
     
    </div>
    <MaintenanceEntitySection
      apiType="Plant"
      addTitle="Add plant"
      valueLabel="Plant name (value)"
      valuePlaceholder="e.g. Plant1"
      codePlaceholder="e.g. Plant2 (optional — defaults to name)"
      listHeading="Plants"
      emptyHint="No plants yet. Use the form on the left."
      deleteModalLabel="plant"
    />
  </div>
);

export default PlantMaintenance;
